module.exports = __webpack_public_path__ + "img/zhu_xc15.66d075e4.jpg";